import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { getApplyParamters } from '../../js/utils/paramters';
import { useCookies } from 'react-cookie';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';

export default function ApplyFloatingBtn() {
  const { t } = useTranslation(['HomePage']);
  const { queryParams } = useNavigationWithQuery();
  const [cookies] = useCookies();

  return (
     <a
  href={`/${(typeof window !== 'undefined' && window.location.pathname.startsWith('/ar')) ? 'ar' : 'en'}/apply${queryParams || ''}`}
  className="button apply-now floating-btn floating-btn__closed"
>
  <Icon name="open-light" />
  <span>{t('applyNow')}</span>
  {/* <div>{t('applicationsClosed')}</div> */}
</a>  );
}
